// src/utils/axiosInstance.js
import axios from "axios";
import store from "./redux/store";
import { LoginSuccess, LoginFailure } from "./redux/slices/authSlice";
import Cookies from "js-cookie";

export const createAxiosInstance = (API_BASE_URL) => {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  // 🔐 Request Interceptor
  instance.interceptors.request.use((config) => {
    const accessToken = store.getState().auth.accessToken;
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  });

  // 🔁 Response Interceptor
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const refreshToken = Cookies.get("refreshToken");
          const res = await axios.post(`${API_BASE_URL}/auth/refresh`, {
            long_lived_token: refreshToken,
          });
          const { access_token } = res.data;

          store.dispatch(
            LoginSuccess({
              accessToken: access_token,
              user_name: localStorage.getItem("user_name"),
            })
          );

          originalRequest.headers.Authorization = `Bearer ${access_token}`;
          return instance(originalRequest);
        } catch (refreshErr) {
          store.dispatch(LoginFailure());
          return Promise.reject(refreshErr);
        }
      }

      return Promise.reject(error);
    }
  );

  return instance;
};
